import * as React from 'react';
import { IconProps, IconWrapper } from './IconWrapper';

export const IconFire: React.FC<IconProps> = ({ children, ...props }) => {
  return (
    <IconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M18.0713 20.1361C16.1959 21.9698 13.6523 23 11.0001 23C8.34793 23 5.80436 21.9698 3.92897 20.1361C2.05358 18.3024 1 15.8153 1 13.2221C1 10.6288 2.05358 8.14177 3.92897 6.30805C3.92897 6.30805 4.75021 8.33325 7.25017 9.55546C7.25017 7.11104 7.87517 3.44442 10.9826 1C13.5001 3.44442 16.1126 4.39407 18.07 6.30805C19.0002 7.21492 19.7379 8.2926 20.2407 9.47915C20.7435 10.6657 21.0016 11.9377 21 13.2221C21.0017 14.5064 20.7439 15.7783 20.2413 16.9649C19.7387 18.1514 19.0012 19.2291 18.0713 20.1361V20.1361Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="stroke-current"
        fill="none"
      />
      <path
        d="M8.17188 16.9745C8.63635 17.3811 9.20811 17.6813 9.83664 17.8486C10.4652 18.0158 11.1311 18.0451 11.7756 17.9336C12.4201 17.8222 13.0233 17.5736 13.5319 17.2097C14.0405 16.8458 14.4389 16.3779 14.6918 15.8474C14.9447 15.3168 15.0443 14.7398 14.9819 14.1675C14.9195 13.5952 14.697 13.0452 14.334 12.5661C13.971 12.0869 13.4787 11.6934 12.9007 11.4202C12.3226 11.1471 11.6765 11.0028 11.0196 11L9.6664 14.5H7C7 15.396 7.39063 16.292 8.17188 16.9745Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="stroke-current"
        fill="none"
      />
    </IconWrapper>
  );
};
